import React from "react";
import {
  List,
  ListItemIcon,
  ListItemText,
  Collapse,
  ListItemButton,
} from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { Link, useLocation } from "react-router-dom";

const RoleBasedMenu = ({ menuItems }) => {
  const [open, setOpen] = React.useState({});
  const location = useLocation();

  const handleClick = (label) => {
    setOpen((prevState) => ({
      ...prevState,
      [label]: !prevState[label],
    }));
  };

  const renderMenuItems = (items, level = 0) => {
    return items.map((item) => {
      const isSelected = location.pathname === item.route;
      const isParentOpen = open[item.label];

      const listItemContent = (
        <>
          {item?.icon && (
            <ListItemIcon
              sx={{
                color:
                  (isSelected || isParentOpen) && level === 0
                    ? "black"
                    : "#FFE300",
              }}
            >
              <span className={`material-icons`}>{item.icon}</span>
            </ListItemIcon>
          )}

          <ListItemText primary={item.label} />
          {item.isNestedRoute && (
            <img
              src="/assets/icons/right_arrow.svg"
              className={`arrow-icon ${isParentOpen ? "open" : ""}`}
              alt="arrow"
              style={{
                transition: "transform 0.3s, fill 0.3s",
                transform: isParentOpen ? "rotate(90deg)" : "rotate(0)",
                filter:
                  isParentOpen && level === 0
                    ? "brightness(0) contrast(100%)"
                    : "none",
              }}
            />
          )}
        </>
      );

      return (
        <React.Fragment key={item.label}>
          {item.isNestedRoute ? (
            <ListItemButton
              sx={{
                pl: 2 * level + 2,
                backgroundColor:
                  isParentOpen && level === 0 ? "#FFE300" : "black",
                color:
                  isParentOpen && level === 0
                    ? "#000"
                    : (isParentOpen && level > 0) || level === 0
                    ? "#FFE300"
                    : "#FFF",
                "&:hover": {
                  backgroundColor: isParentOpen && level === 0 && "#FFE300",
                },
                margin: "6px",
                borderRadius: "10px",
              }}
              onClick={() => handleClick(item.label)}
            >
              {listItemContent}
            </ListItemButton>
          ) : (
            <ListItemButton
              sx={{
                pl: 2 * level + 2,
                color:
                  isSelected && level === 0
                    ? "black"
                    : level === 0 || isSelected
                    ? "#FFE300"
                    : "#FFF",
                backgroundColor:
                  isSelected && level === 0 ? "#FFE300" : "black",
                margin: "6px",
                borderRadius: "10px",
              }}
              component={Link}
              to={item.route}
            >
              {listItemContent}
            </ListItemButton>
          )}
          {item.isNestedRoute && item.nestedItems && (
            <Collapse in={open[item.label]} timeout="auto" unmountOnExit>
              <List
                sx={{ color: "white !important" }}
                component="div"
                disablePadding
              >
                {renderMenuItems(item.nestedItems, level + 1)}
              </List>
            </Collapse>
          )}
        </React.Fragment>
      );
    });
  };

  return <List>{renderMenuItems(menuItems)}</List>;
};

export default RoleBasedMenu;
